import { defineMessages } from '../define';

export default defineMessages({
  // Editor screen
  'editor.title': { ru: 'Новый монтаж', en: 'New edit' },
  'editor.demoFailed': { ru: 'Не удалось загрузить демо. Попробуйте ещё раз.', en: "Couldn't load the demo. Please try again." },
  'editor.offline': { ru: 'Нет соединения с интернетом', en: 'No internet connection' },
  'editor.hookSample': { ru: 'Три ошибки в первом экране', en: 'Three mistakes in your first screen' },
  'editor.mode.full': { ru: 'Полный рассказ', en: 'Full story' },
  'editor.mode.summary': { ru: 'Выжимка', en: 'Summary' },
  'editor.duration.auto': { ru: 'Авто', en: 'Auto' },
  'editor.duration.s': { ru: 'до {n} с', en: 'up to {n} s' },
  'editor.mood.calm': { ru: 'Спокойное', en: 'Calm' },
  'editor.mood.upbeat': { ru: 'Бодрое', en: 'Upbeat' },
  'editor.mood.dramatic': { ru: 'Драматичное', en: 'Dramatic' },
  'editor.mood.corporate': { ru: 'Деловое', en: 'Corporate' },
  'editor.mood.lofi': { ru: 'Лоу-фай', en: 'Lo-fi' },
  'editor.mood.epic': { ru: 'Эпичное', en: 'Epic' },
  'editor.mood.off': { ru: 'Без музыки', en: 'No music' },
  'editor.framing.auto': { ru: 'Авто', en: 'Auto' },
  'editor.framing.center': { ru: 'Центр', en: 'Center' },
  'editor.framing.blur': { ru: 'Размытые поля', en: 'Blurred edges' },
  'editor.captionLang.auto': { ru: 'Язык речи', en: 'Speech language' },
  'editor.captionLang.ru': { ru: 'Русский', en: 'Русский' },
  'editor.captionLang.en': { ru: 'English', en: 'English' },

  'editor.section.text': { ru: 'Субтитры и хук', en: 'Subtitles and hook' },
  'editor.subtitles.style': { ru: 'Стиль субтитров', en: 'Subtitle style' },
  'editor.subtitles.highlight': { ru: 'Цвет подсветки слова', en: 'Word highlight color' },
  'editor.subtitles.font': { ru: 'Шрифт субтитров', en: 'Subtitle font' },
  'editor.subtitles.size': { ru: 'Размер субтитров', en: 'Subtitle size' },
  'editor.subtitles.box': { ru: 'Плашка', en: 'Background' },
  'editor.subtitles.boxAria': { ru: 'Плашка под субтитрами', en: 'Subtitle background' },
  'editor.subtitles.sound': { ru: 'Звук печати', en: 'Typing sound' },
  'editor.subtitles.soundHint': { ru: 'Тихий щелчок при появлении слова в ролике', en: 'A soft click as each word appears in the reel' },
  'editor.hook.title': { ru: 'Хук в начале', en: 'Hook at the start' },
  'editor.hook.hint': { ru: 'Плашка с фразой в первые секунды, текст можно поправить после монтажа', en: 'A title card with a phrase in the first seconds. You can edit the text after the edit is done' },
  'editor.hook.accent': { ru: 'Акцент в хуке', en: 'Hook emphasis' },
  'editor.hook.style': { ru: 'Оформление хука', en: 'Hook style' },
  'editor.caption.title': { ru: 'Описание и хэштеги', en: 'Caption and hashtags' },
  'editor.caption.hint': { ru: 'Подберём автоматически на выбранном языке', en: "We'll write them automatically in the language you pick" },
  'editor.caption.aria': { ru: 'Язык описания', en: 'Caption language' },

  'editor.section.picture': { ru: 'Картинка', en: 'Picture' },
  'editor.color.title': { ru: 'Цвет видео', en: 'Video color' },
  'editor.framing.title': { ru: 'Кадрирование головы', en: 'Face framing' },
  'editor.framing.hint': { ru: 'Как привести горизонтальную запись к 9:16', en: 'How to fit a landscape recording into 9:16' },
  'editor.framing.aria': { ru: 'Кадрирование', en: 'Framing' },
  'editor.zooms.title': { ru: 'Зумы на акцентах', en: 'Emphasis zooms' },
  'editor.zooms.hint': { ru: 'Лёгкое приближение на ключевой фразе и возврат к общему плану', en: 'A gentle zoom-in on the key phrase, then back to the wide shot' },
  'editor.transitions': { ru: 'Переходы', en: 'Transitions' },

  'editor.section.montage': { ru: 'Монтаж', en: 'Editing' },
  'editor.montage.mode': { ru: 'Режим монтажа', en: 'Editing mode' },
  'editor.montage.summaryHint': { ru: 'ИИ оставит главную мысль, необходимый контекст и вывод. Паузы, запинки и неудачные дубли уберём', en: 'AI keeps the main idea, the context it needs and the takeaway. We cut pauses, stumbles and bad takes' },
  'editor.montage.fullHint': { ru: 'Сохраним все законченные мысли автора. Уберём паузы, запинки и неудачные дубли', en: "We keep every complete thought. We cut pauses, stumbles and bad takes" },
  'editor.montage.summaryLength': { ru: 'Длительность выжимки', en: 'Summary length' },
  'editor.montage.summaryLengthHint': { ru: 'Авто — до 60 секунд. Сокращаем целыми фразами, сохраняя смысл главной мысли', en: 'Auto means up to 60 seconds. We trim whole phrases and keep the main idea intact' },
  'editor.montage.pauses': { ru: 'Чистка пауз', en: 'Pause trimming' },
  'editor.montage.pausesHint': { ru: 'Сокращает заминки, сохраняя паузы между мыслями', en: 'Shortens hesitations but keeps the pauses between thoughts' },
  'editor.montage.speed': { ru: 'Скорость видео', en: 'Video speed' },
  'editor.montage.speedHint': { ru: 'Ускоряет речь и видео, голос звучит без искажений. Музыка и хук не ускоряются', en: 'Speeds up speech and video while the voice stays natural. Music and the hook are not sped up' },

  'editor.section.sound': { ru: 'Звук', en: 'Sound' },
  'editor.sound.mood': { ru: 'Настроение музыки', en: 'Music mood' },
  'editor.sound.volume': { ru: 'Громкость музыки', en: 'Music volume' },
  'editor.sound.noise': { ru: 'Шумоподавление', en: 'Noise reduction' },

  'editor.paywall.aria': { ru: 'Купить видео', en: 'Buy reels' },
  'editor.paywall.reserved': { ru: 'Монтаж уже в работе.', en: 'An edit is already in progress.' },
  'editor.paywall.empty': { ru: 'У вас закончились ролики.', en: "You're out of reels." },
  'editor.paywall.addon': { ru: 'Докупите ещё {n} видео за {price}.', en: { one: 'Add {n} more reel for {price}.', other: 'Add {n} more reels for {price}.' } },
  'editor.paywall.addonOff': { ru: 'Докупка видео сейчас недоступна.', en: 'Extra reels are unavailable right now.' },
  'editor.paywall.subscribe': { ru: 'Купите подписку:', en: 'Get a subscription:' },
  'editor.paywall.pack': { ru: '{title} · {n} видео/мес.', en: { one: '{title} · {n} reel/mo', other: '{title} · {n} reels/mo' } },
  'editor.paywall.buyMore': { ru: 'Докупить видео', en: 'Buy more reels' },
  'editor.paywall.balance': { ru: 'Посмотреть баланс', en: 'View balance' },
  'editor.paywall.choose': { ru: 'Выбрать подписку', en: 'Choose a plan' },
  'editor.status.done': { ru: 'Ролик готов — нажмите «Смотреть» внизу.', en: 'Your reel is ready. Tap “Watch” below.' },
  'editor.status.working': { ru: 'Готовый ролик придет в чат через 3–6 минут, приложение можно закрыть.', en: "Your reel will arrive in the chat in 3–6 minutes. You can close the app." },
  'editor.caption.exhausted1': { ru: 'Ролики закончились', en: "You're out of reels" },
  'editor.caption.exhausted2': { ru: 'Выберите тариф, чтобы продолжить', en: 'Choose a plan to continue' },
  'editor.caption.trial': { ru: 'Бесплатно с водяным знаком ReelMill', en: 'Free with a ReelMill watermark' },
  'editor.caption.clean': { ru: 'Без водяного знака', en: 'No watermark' },
  'editor.caption.spend': { ru: 'Спишется 1 из {n} доступных', en: 'Uses 1 of {n} available' },

  // Controls
  'editor.chips.back': { ru: 'Назад', en: 'Back' },
  'editor.chips.next': { ru: 'Дальше', en: 'Next' },

  // Color
  'editor.colorPreview.aria': { ru: 'Превью цветокоррекции', en: 'Color grade preview' },
  'editor.colorPreview.alt': { ru: 'Пример кадра для оценки цветокоррекции', en: 'Sample frame for judging the color grade' },
  'editor.colorPreview.label': { ru: 'Пример · {name}', en: 'Sample · {name}' },
  'editor.colorPreview.original': { ru: 'Оригинал', en: 'Original' },
  'editor.color.showFilter': { ru: 'Показать фильтр', en: 'Show filter' },
  'editor.color.compare': { ru: 'Сравнить с оригиналом', en: 'Compare with original' },
  'editor.color.filter': { ru: 'Цветовой фильтр', en: 'Color filter' },
  'editor.color.intensity': { ru: 'Интенсивность', en: 'Intensity' },
  'editor.color.intensityAria': { ru: 'Интенсивность фильтра', en: 'Filter intensity' },

  // Audio
  'editor.audio.off': { ru: 'Шумоподавление выключено. Громкость речи по-прежнему выравнивается.', en: 'Noise reduction is off. Speech volume is still leveled.' },
  'editor.audio.strong': { ru: 'Для заметного постоянного шума. Если речь трудно отделить от фона, обработка останется мягкой. После монтажа сравните звучание.', en: "For clearly audible constant noise. If speech is hard to separate from the background, the effect stays gentle. Compare the sound once the edit is ready." },
  'editor.audio.auto': { ru: 'Мягко приглушает постоянный фон. Чистые записи и неуверенно распознанный шум остаются без шумоподавления.', en: 'Gently reduces steady background noise. Clean recordings and noise we are not sure about are left untouched.' },

  // Subtitle position
  'editor.position.top': { ru: 'Сверху', en: 'Top' },
  'editor.position.bottom': { ru: 'Снизу', en: 'Bottom' },
  'editor.position.manual': { ru: 'Вручную', en: 'Manual' },
  'editor.position.title': { ru: 'Расположение субтитров', en: 'Subtitle position' },
  'editor.position.hint': { ru: 'Перетащите субтитры и хук на превью, чтобы поставить их куда удобно', en: 'Drag the subtitles and hook on the preview to place them anywhere' },
  'editor.position.hook': { ru: 'Расположение хука', en: 'Hook position' },

  // Subtitle preview
  'editor.preview.aria': { ru: 'Предпросмотр кадра с субтитрами', en: 'Frame preview with subtitles' },
  'editor.preview.sample': { ru: 'Но вот уже более 9 лет я в кадре', en: "But I've been on camera for more than 9 years" },

  // Transitions
  'editor.transition.aria': { ru: 'Тип перехода', en: 'Transition type' },
  'editor.transition.none': { ru: 'Нет', en: 'None' },
  'editor.transition.duration': { ru: 'Длительность', en: 'Duration' },
  'editor.transition.durationAria': { ru: 'Длительность перехода', en: 'Transition duration' },
  'editor.transition.seconds': { ru: '{value} с', en: '{value} s' },
  'editor.transition.example': { ru: 'Пример перехода', en: 'Transition example' },
  'editor.transition.scene1': { ru: 'Пример · первый фрагмент', en: 'Sample · first clip' },
  'editor.transition.scene2': { ru: 'Пример · второй фрагмент', en: 'Sample · second clip' },
  'editor.transition.caption': { ru: 'Речь продолжается', en: 'Speech continues' },
  'editor.transition.play': { ru: 'Посмотреть переход', en: 'Preview transition' },
  'editor.transition.hint': { ru: 'На стыках фрагментов. На коротких фрагментах переход сокращается; речь и длительность ролика сохраняются.', en: 'Applied between clips. On short clips the transition gets shorter; speech and reel length stay the same.' },

  // Demo
  'editor.demo.file': { ru: 'Демо {n}.mp4', en: 'Demo {n}.mp4' },

  // Upcoming highlight colors
  'ls.Белый': { ru: 'Белый', en: 'White' },
  'ls.Чёрный': { ru: 'Чёрный', en: 'Black' },
  'ls.Дакар': { ru: 'Дакар', en: 'Dakar' },
  'ls.Вишня': { ru: 'Вишня', en: 'Cherry' },
  'ls.Небесный': { ru: 'Небесный', en: 'Sky' },
  'ls.Матча': { ru: 'Матча', en: 'Matcha' },

  // Labels from @reels/shared used by the editor
});
